<template>
  <div v-if="visible" class="opc-open-invoice" :class="isIframesModal ? 'opc-open-invoice-modal' : ''">
    <h3 class="opc-cart-item__title text-capitalize">
      <span class="opc-cart-item__subtitle">
        {{ $t('billing.invoice.cart.label') }}
        <zm-tooltip style="display: inline-block !important;" v-if="openInvoiceTooltips" disallow-learn-about>
          <template #content>
          <div v-html="openInvoiceTooltips"></div>
          </template>
          <tips-icon type="info" aria-label="learn more about Open Invoices" />
        </zm-tooltip>
      </span>
      <span class="opc-cart-item__value text-no-capitalize">
        {{ openInvoiceTotalAmountView }}
      </span>
    </h3>
    <div class="opc-cart-item__text">
      {{ openInvoiceCountView }}
    </div>
    <zm-button data-testid="checkout-button-397" class="opc-open-invoice__sub-item opc-success-no-hide-button" type="link" v-for="item in openInvoiceList"
               :key="item.invoiceNumber"
               @click="handleInvoicePreview(item)">
      {{ item.invoiceNumber }}
    </zm-button>
    <invoice-dialog
      :visible="invoicePreviewVisible"
      :invoice-number="currentSelectInvoiceNumber"
      @close="handleInvoiceDialogClose" />
  </div>
</template>

<script type="text/jsx" lang="jsx">
import InvoiceDialog from '@/views/config/shopping-cart/open-invoice/invoice-dialog.vue';
import { isEmptyVal } from '@/utils';
import _ from "lodash";
import { dateTimeFormat } from '@/utils/dateformat';

export default {
  name: 'open-invoice-cart',
  components: { InvoiceDialog },
  data() {
    return {
      invoicePreviewVisible: false,
      currentSelectInvoiceNumber: null,
    };
  },
  props: {
    openInvoiceList: {
      type: Array,
      default: () => [],
    },
    openInvoiceTotalAmount: {
      type: Number,
      default: 0,
    },
    openInvoiceOriginalTotalAmount: {
      type: Number,
      default: 0,
    },
    currentCreditBalance: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isIframesModal() {
      return this.$context.is.modal;
    },
    openInvoiceTotalAmountView() {
      return this.$money(this.openInvoiceTotalAmount > 0 ? this.openInvoiceTotalAmount : 0);
    },
    openInvoiceCountView() {
      return this.$t('billing.invoice.cart.unit', [this.openInvoiceCount]);
    },
    openInvoiceCount() {
      return this.openInvoiceList?.length || 0;
    },
    visible() {
      return !isEmptyVal(this.openInvoiceList);
    },
    openInvoiceTooltips() {
      const invoiceItem = _.find(this.openInvoiceList, (p) => !isEmptyVal(p.dueDate));
      const dueDate = invoiceItem?.dueDate ? dateTimeFormat(invoiceItem.dueDate) : '';
      return dueDate ? this.$t('billing.invoice.invoice_tips', [dueDate]) : '';
    },
  },
  methods: {
    handleInvoicePreview(item) {
      this.invoicePreviewVisible = true;
      this.currentSelectInvoiceNumber = item?.invoiceNumber;
    },
    handleInvoiceDialogClose() {
      this.invoicePreviewVisible = false;
    },
  },
};
</script>

<style lang="scss">
.opc-open-invoice {
  padding-bottom: 8px;

  &.opc-open-invoice-modal {
    .opc-cart-item__subtitle {
      font-size: 18px;
      font-weight: 700;
      line-height: 27px;
    }
  }

  &__sub-item {
    &.zbo-button {
      display: flex;
      padding: 0px !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }

    &.zbo-button + .zbo-button {
      margin-left: 0px !important;
    }
  }
}
</style>
